import { useEffect, useState } from "react"
import { correo, getCorreosWS } from "@/core/api/sigma/services/logcorreo"
import { BodyTableLog, LogTable } from "../components/LogTable"
import { FormProvider, useForm } from "react-hook-form"
import { PaisSelect } from "@/features/common/components"
import { useSearchParams } from "react-router-dom"


export const LogCorreoPage = () => {
    const [table,setTable] = useState([] as BodyTableLog[])
    const methods = useForm({
        defaultValues: {
        country_id: ''
        }
    });

    const [searchParams] = useSearchParams();
    const pais = searchParams.get("pais");   // "0"

    const { control, formState: { errors }, unregister, register } = methods;
    const [cpais,setCpais] = useState(pais)

   
    useEffect(()=>{
        getCorreosWS({
            // cpais: cpais,
            csistema: "n8n",
            ctipo_correo: 'Poliza_RC',
            cpais: ""
        }).then((data)=>{
            setTable(data.map((value)=>(
                {
                    fecha: value.fcorreo,
                    xemail: value.xusuario,
                    iestado: value.iestatus,
                    xmensaje:value.xcorreo
                } as BodyTableLog
            ))) 
        }).catch((error)=>{
            setTable([])
            console.log(error)
        })
    },[cpais])

    const fetchBuscarCorreos = ()=>{
        const formData = methods.getValues();
        if (formData.country_id) {
            setTable([])
            console.log(formData.country_id)
            setCpais(formData.country_id)
        }
    }

    
    return (
        <FormProvider {...methods}>
            <div pantalla="LOGCORREO" className="container container-for-cards flex-column gap-3">
                <h2 className="mb-4 text-xl font-semibold text-center text-gray-800">
                    Envió de Notificaciones y seguimientos de Cambios 
                </h2>
                <div className="flex-row justify-center">
                    <PaisSelect
                    control={control}
                    name={"country_id"}
                    label={"País"}
                    required={false}
                    errors={errors}
                    />
                    <button type="submit"
                        onClick={methods.handleSubmit((data) => {
                        fetchBuscarCorreos();
                        })}
                        className="buttons btn-success px-4 py-1 border-0">
                        Buscar
                    </button>
                </div>
                <LogTable table={table}></LogTable>
            </div>
        </FormProvider>

    )
}